import React from 'react'
import { Container } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { observer } from 'mobx-react'
import { application, convertToBoolean, enableAccountSettings } from 'src/utils'
import MyAccountMenu from './MyAccountMenu'
import MyAccountSection from './MyAccountSection'
import { tokenExContainer, paymetricContainer } from 'src/models'
import { MetaDecorator } from 'src/views/components'
import { APPConfig } from 'config/appConfig'
import { pageNames } from 'src/routes/pathParams'
import './styles.scss'

@observer
class MyAccount extends React.Component {
  constructor(props) {
    super(props)
    /**
     * @note
     * loading tokenExContainer/paymetric dependencies here
     */
    if (
      convertToBoolean(
        APPConfig?.getAppConfig()?.enableDirectPaymetricAndAccertifyIntegration
      )
    ) {
      paymetricContainer.loadPaymetricScript()
    } else {
      tokenExContainer.loadTokenExScript()
    }
    // tokenExContainer.getTokenExAuthKeyFromSFO()
  }

  checkPageTypes = currentPage => {
    return (
      currentPage.includes(pageNames.accountSettings) ||
      currentPage.includes(pageNames.myaccountprivacy) ||
      currentPage.includes(pageNames.b2bUserManagement) ||
      currentPage.includes(pageNames.myaccountdirectselleridcard)
    )
  }

  render() {
    const currentPage = this.props?.history?.location?.pathname || ''
    const myAccountTitle = i18nTranslate(
      'myAccountPage.title',
      'MyAccount | Nu Skin'
    )
    const wrapperClass =
      enableAccountSettings() && this.checkPageTypes(currentPage)
        ? 'mfe-account-container px-0'
        : ''
    const customStyle = application.isMobile
      ? 'd-block'
      : 'd-md-flex flex-nowrap'

    return (
      <>
        <MetaDecorator
          title={myAccountTitle}
          imageUrl=""
          imageAlt=""
          description={i18nTranslate('myAccount.desc', 'My Account page')}
          location={this.props}
        />
        <div className="myaccount-wrapper container-fluid pl-0 pr-0">
          <Container
            className={`account-container my-0 mx-auto d-md-flex ${customStyle} ${wrapperClass}`}>
            <MyAccountMenu
              history={this.props.history}
              currentPage={currentPage}
              useAccountProfileSideMenu={this.props.useAccountProfileSideMenu}
            />
            <MyAccountSection {...this.props} />
          </Container>
        </div>
      </>
    )
  }
}

// export default MyAccount
export default MyAccount
